import { render } from "./MainVouchers.vue?vue&type=template&id=6ece1647&scoped=true"
import script from "./MainVouchers.vue?vue&type=script&lang=js"
export * from "./MainVouchers.vue?vue&type=script&lang=js"

import "./MainVouchers.vue?vue&type=style&index=0&id=6ece1647&scoped=true&lang=css"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ece1647"]])

export default __exports__